export const integrationControl = {
  productEntitlements: "Product entitlements",
  entitlementHelp:
    "Choose an entitlement and record its contract terms. Current validity also depends on its dates; saving terms does not enable a provider.",

  rightsSections: "Access sections",
  releaseRights: "Service access",
  commercialRights: "Commercial terms",
  commercialIntro:
    "Manage product entitlements and contract terms. Provider access is managed separately under Service access.",

  productSections: "Product settings sections",
  productOverview: "Overview",
  productMissing: "Integration product not found.",
  connectionIssues: "Connections to review",
  connectionsLink: "View all connections",
  noConnectionIssues:
    "No connections flagged for review. This is not a live provider health check.",
  testNotPassed: "Serving version has not passed testing or certification",
  noActiveVersion: "No serving version",
  disabledConnection: "Connection disabled",
  rollouts: "Capability rollout by app",
  rolloutIntro:
    "Switches default to off. Enabling allows readiness evaluation; configuration, entitlement, testing and ACK gates must still pass.",
  capability: "Capability",
  revision: "Revision",

  accounts: "Platform accounts",
  connections: "Connections",
  bindings: "App bindings",
  routing: "Email routing",
  rights: "Entitlements & commerce",
  health: "Integration status",
  product: "Product",
  provider: "Provider",
  capabilities: "Adapter capabilities",
  capabilitiesIntro: "Adapter support does not mean a feature is currently ready.",
  noCapabilities: "No catalog capabilities declared.",
  empty: "No data yet.",
  loading: "Loading…",
  reload: "Reload",
  open: "Open settings",
  account: "Account",
  connection: "Connection",
  activeVersion: "Version in use",
  candidate: "Latest candidate",
  state: "State",
  app: "App",
  environment: "Environment",
  enabled: "Enabled",
  disabled: "Disabled",
  drainingInfo: "No new outbound",
  deadline: "Drain deadline (Vietnam time)",
  platform: "Platform",
  lab: "Lab",
  entitlement: "Entitlement",
  storedStatus: "Contract status",
  effectiveStatus: "Current effective status",
  contractRef: "Contract reference",
  effectiveFrom: "Effective from (Vietnam time)",
  expiresAt: "Expires at (Vietnam time)",
  note: "Note",
  save: "Save entitlement",
  saved: "Saved; check sync results below.",
  pending: "Pending",
  negotiating: "Negotiating",
  active: "Active",
  suspended: "Suspended",
  expired: "Expired",
  routeIntro: "Email routing per app: primary, standby and validation gates.",
  healthIntro:
    "Open email route signals and connection test state; no open signals do not prove provider health.",
  noSignals: "No open signals",
  connectionStatus: "Connection state",
  sync: "Sync results",
  back: "Providers",
  apps: "Apps using this product",
  resell: "Resell",
  internal_use: "Internal use",
  production_api: "Production API",
  white_label: "White label",
  bulk_api: "Bulk API",
} as const;
